import { render, staticRenderFns } from "./InputResetPassword.vue?vue&type=template&id=b763a25c&scoped=true&"
import script from "./InputResetPassword.vue?vue&type=script&lang=js&"
export * from "./InputResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./InputResetPassword.vue?vue&type=style&index=0&id=b763a25c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763a25c",
  null
  
)

export default component.exports